module.exports = __webpack_public_path__ + "img/santa-hat.7bd7fee3.png";